import React, { memo } from "react";
import { motion } from "framer-motion";

function RemoveCart(props) {
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,.45)",
          zIndex: 1040, backdropFilter: "blur(4px)",
        }}
        onClick={() => props.setShowModal("")}
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.88, y: 24 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.88, y: 24 }}
        transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
        style={{
          position: "fixed", top: "50%", left: "50%",
          transform: "translate(-50%,-50%)",
          zIndex: 1050, width: "100%", maxWidth: 400,
          padding: "0 16px",
        }}
      >
        <div style={{
          background: "#fff", borderRadius: 20,
          boxShadow: "0 24px 80px rgba(0,0,0,.22)",
          overflow: "hidden",
        }}>
          {/* Top accent bar */}
          <div style={{ height: 4, background: "linear-gradient(90deg,#8217b4,#cf84fa)" }} />

          <div style={{ padding: "32px 28px 28px", textAlign: "center" }}>
            {/* Icon */}
            <div style={{
              width: 64, height: 64, borderRadius: "50%",
              background: "#fdf0f7", margin: "0 auto 18px",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c8329b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                <path d="M10 11v6"/>
                <path d="M14 11v6"/>
                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
              </svg>
            </div>

            <h5 style={{
              fontFamily: "var(--font-display)",
              fontSize: "20px", fontWeight: 600, color: "#1c1c1e",
              margin: "0 0 8px",
            }}>
              Remove Item?
            </h5>
            <p style={{ fontSize: 14, color: "#6d6d72", margin: "0 0 28px", lineHeight: 1.5 }}>
              This item will be removed from your cart. You can add it back anytime.
            </p>

            <div style={{ display: "flex", gap: 12 }}>
              <button
                onClick={() => props.setShowModal("")}
                style={{
                  flex: 1, padding: "12px 0",
                  background: "#f5f5f7", border: "none",
                  borderRadius: 10, fontSize: 14, fontWeight: 600,
                  color: "#4f3267", cursor: "pointer",
                  transition: "background .15s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#ede8f5"}
                onMouseLeave={(e) => e.currentTarget.style.background = "#f5f5f7"}
              >
                Cancel
              </button>
              <button
                onClick={() => props.removeItemFromCart(props.showModal)}
                style={{
                  flex: 1, padding: "12px 0",
                  background: "linear-gradient(135deg,#8217b4,#c8329b)",
                  border: "none", borderRadius: 10,
                  fontSize: 14, fontWeight: 600, color: "#fff",
                  cursor: "pointer", transition: "opacity .15s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = "0.88"}
                onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default memo(RemoveCart);